import { makeStyles } from '@material-ui/core/styles'

const useMyPlanStyles = makeStyles(theme => ({
  contentContainer: {
    margin: '2rem auto 6rem',
    maxWidth: 832,
    padding: theme.spacing(0, 2),
  },
  intro: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  card: {
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  cardLogo: {
    height: 36,
    width: 'auto',
    display: 'block',
    minWidth: 120,
  },
  cardLogoPlus: {
    height: 28,
    maxWidth: 168,
    width: 'auto',
    display: 'block',
    minWidth: 120,
  },
  cardDivider: {
    height: 1,
    backgroundColor: '#E0E0E0',
  },
  cardContent: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  planBadge: {
    fontSize: '0.8125rem',
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#172024',
    backgroundColor: '#EBF0F2',
    padding: theme.spacing(1, 2),
    borderRadius: 999,
    whiteSpace: 'nowrap',
  },
  plusIntro: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  featureGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(1.75, 3),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  featureColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.75),
  },
  featureItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
  },
  featureIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    borderRadius: 4,
    backgroundColor: '#EBF0F2',
    flexShrink: 0,
    marginTop: 1,
  },
  featureIcon: {
    fontSize: 14,
    color: '#172024',
  },
  featureText: {
    fontSize: '0.875rem',
    lineHeight: 1.45,
    color: '#172024',
  },
}))

export default useMyPlanStyles
